export const CHANGELOG_PATH = "/changelog";
